var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinterListEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 248,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.2464,
    y: 77.6483,
    width: 154.668,
    height: 28.0107,
    rx: 14.0054,
    fill: "#D3E9F1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.08571,
    y: 143.413,
    width: 154.668,
    height: 28.0107,
    rx: 14.0054,
    fill: "#D3E9F1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.8788,
    y: 110.531,
    width: 180.243,
    height: 28.0107,
    rx: 14.0054,
    fill: "#D3E9F1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60.6714,
    y: 42.331,
    width: 125.439,
    height: 171.718,
    rx: 8,
    fill: "#3B6397"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.0857 53.1428C70.8766 53.1428 69.0857 54.9337 69.0857 57.1428V199.714C69.0857 201.923 70.8766 203.714 73.0857 203.714H144.696C146.872 203.714 148.648 201.976 148.695 199.8L148.883 191.086C149.652 198.187 155.666 203.714 162.972 203.714C170.798 203.714 177.143 197.37 177.143 189.543V152.343H177.143V57.1428C177.143 54.9337 175.352 53.1428 173.143 53.1428H73.0857Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.873 130.345L111.854 123.326C111.262 122.734 110.536 122.438 109.675 122.438C108.815 122.438 108.062 122.761 107.416 123.406C106.824 123.998 106.529 124.751 106.529 125.666C106.529 126.58 106.824 127.333 107.416 127.925L116.614 137.123C117.206 137.714 117.959 138.01 118.873 138.01C119.788 138.01 120.541 137.714 121.132 137.123L139.447 118.807C140.039 118.216 140.335 117.49 140.335 116.629C140.335 115.768 140.012 115.015 139.367 114.37C138.775 113.778 138.022 113.482 137.108 113.482C136.193 113.482 135.44 113.778 134.848 114.37L118.873 130.345ZM123.391 156.809C118.927 156.809 114.731 155.961 110.805 154.266C106.878 152.571 103.463 150.272 100.558 147.369C97.6535 144.465 95.3546 141.049 93.6613 137.123C91.968 133.196 91.1203 129 91.1181 124.536C91.1181 120.071 91.9659 115.876 93.6613 111.949C95.3567 108.023 97.6556 104.607 100.558 101.703C103.463 98.798 106.878 96.4991 110.805 94.8058C114.731 93.1126 118.927 92.2648 123.391 92.2627C127.856 92.2627 132.051 93.1104 135.978 94.8058C139.905 96.5012 143.32 98.8002 146.225 101.703C149.129 104.607 151.429 108.023 153.125 111.949C154.82 115.876 155.667 120.071 155.665 124.536C155.665 129 154.817 133.196 153.122 137.123C151.426 141.049 149.127 144.465 146.225 147.369C143.32 150.274 139.905 152.574 135.978 154.269C132.051 155.965 127.856 156.811 123.391 156.809Z",
    fill: "#07CF86"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.062 45.985C130.85 44.7545 131.307 43.2916 131.307 41.722C131.307 37.3501 127.763 33.8059 123.391 33.8059C119.019 33.8059 115.475 37.3501 115.475 41.722C115.475 43.2916 115.932 44.7545 116.72 45.985H105.123C101.424 45.985 98.425 48.9839 98.425 52.6832C98.425 56.3825 101.424 59.3814 105.123 59.3814H141.659C145.358 59.3814 148.357 56.3825 148.357 52.6832C148.357 48.9839 145.358 45.985 141.659 45.985H130.062Z",
    fill: "#3B6397"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.8 175.371H94.6239H67.5358H53.3643V188.927H53.3775C53.3687 189.131 53.3643 189.336 53.3643 189.543C53.3643 197.369 59.7091 203.714 67.5358 203.714H162.972C155.145 203.714 148.8 197.369 148.8 189.543V175.371Z",
    fill: "#87AFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinterListEmptyState);
export default __webpack_public_path__ + "static/media/linter-list-empty-state.82cfc4b2e607b3f14d165e187d2f831c.svg";
export { ForwardRef as ReactComponent };